import OnboardingSaveSvg from '@/../assets/illustrations/onboarding-save.svg';
import OnboardingSaveJaSvg from '@/../assets/illustrations/onboarding-save.ja.svg';
import { useTranslation } from '@/i18n';

const SVG_NATURAL_WIDTH = 412;
const SVG_NATURAL_HEIGHT = 437;

interface IllustrationProps {
  readonly width: number;
  readonly height: number;
}

export const OnboardingSaveIllustration = ({ width, height }: IllustrationProps) => {
  const { locale } = useTranslation();
  const Svg = locale === 'ja' ? OnboardingSaveJaSvg : OnboardingSaveSvg;
  const scale = Math.min(width / SVG_NATURAL_WIDTH, height / SVG_NATURAL_HEIGHT);
  return (
    <Svg
      height={SVG_NATURAL_HEIGHT * scale}
      testID="onboarding-save-illustration"
      width={SVG_NATURAL_WIDTH * scale}
    />
  );
};
